import React, { Component } from 'react';
import PT from 'prop-types';
import { ReactFormField } from './reactformfield';
import { map, find, compact, flatMap } from 'lodash';

const up = require('react-addons-update');

export class ReactFormFieldList extends Component {
    constructor(props) {
        super(props);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleFieldOrSubFieldChange = this.handleFieldOrSubFieldChange.bind(this);
    }
    
    // TODO: Replace the content of this function by react immutable nad es6 process.
    handleValueChange(fieldName, newVal) {
        if(this.props.onChange) {
            const change = {};
            change[fieldName] = newVal;
            this.props.onChange(up(this.props.formValues, { [fieldName]: { $set: newVal } }));
        }
    }

    handleFieldOrSubFieldChange(field, subField) {
        const changes = up(this.props.formValues, { 
            [field.name]: { $set: field.value },
            [subField.name]: { $set: subField.value}
        });
        this.props.onChange(changes);
    }

    render() {
        const ReactFormFieldListView = this.props.viewProvider.getFormFieldListView();

        let fieldInfoSuppCtls = null;

        if(this.props.formInfoSupp) {
            fieldInfoSuppCtls = map(this.props.formInfoSupp, (f) => {
                return (
                    <ReactFormField 
                        key={f.name} 
                        field={f}
                        value={f.value}
                        readOnly={true}
                        viewProvider={this.props.viewProvider}
                        lang={this.props.lang}
                    />
                );
            });
        }
        
        const fieldCtls = map(this.props.fields, (f) => {
            if((f.editable === undefined || f.editable) && !f.isSubField) {
                return (
                    <ReactFormField 
                        key={f.name}
                        name={f.name}
                        example={f.example}
                        field={f} 
                        subFields={getFieldPossibleSubFields(this.props, f)}
                        readOnly={this.props.readOnly}
                        validationErrors={this.props.validationErrors[f.name]} 
                        validator={this.props.validator}
                        value={this.props.formValues[f.name]} 
                        onChange={this.handleValueChange} 
                        showValidationErrors={this.props.showValidationErrors}
                        viewProvider={this.props.viewProvider}
                        indentation={this.props.indentation}
                        lang={this.props.lang}
                        onFieldOrSubFieldChange={this.handleFieldOrSubFieldChange}
                    />
                );
            }
            return null;
        });
        return this.props.display ? 
        <form>
            <ReactFormFieldListView indentation={this.props.indentation}>
                {fieldInfoSuppCtls}
                {fieldCtls}
            </ReactFormFieldListView>
        </form> : null;
    }
}

ReactFormFieldList.propTypes = {
    fields: PT.array, // Array of shapes?
    formValues: PT.object,
    onChange: PT.func,
    readOnly: PT.bool,
    validationErrors: PT.any,
    validator: PT.func,
    showValidationErrors: PT.bool,
    viewProvider: PT.object,
    formInfoSupp: PT.arrayOf(PT.shape({ // Il s'agit d'un tableau de champs supplémentaire visibles et non éditables
        name: PT.string,
        value: PT.value
    })),
    display: PT.bool,
    indentation: PT.number,
    lang: PT.string
};

ReactFormFieldList.defaultProps = {
    formValues: {},
    display: true
};

function getFieldPossibleSubFields(props, field) {
    let subFields = [];
    if (field.type === "TAGS") {
        const subFieldNames = compact(map(field.possibleValues, "subField"));
        subFields.push(map(subFieldNames, subFieldName => {
            const subField = find(props.fields, ['name', subFieldName]);
            if (subField) {
                subField.value = props.formValues[subFieldName];
                subField.validationErrors = props.validationErrors[subFieldName];
                subField.showValidationErrors = props.showValidationErrors;
                return subField;
            }
        }));
    }
    return flatMap(subFields);
}
